import script from "./SearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchView.vue?vue&type=script&setup=true&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=532d2477&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532d2477"]])

export default __exports__